import { getAllPosts } from '@/lib/blog';
import '@/styles/landing.css';
import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/blog/')({
    component: BlogPage,
});

const POSTS = getAllPosts();

export function BlogPage() {
    return (
        <div className="sw-lp light">
            {/* Header / Nav */}
            <header className="lp-blog-header">
                <nav className="lp-blog-nav">
                    <Link to="/">
                        <img
                            src="https://res.cloudinary.com/flannery38/image/upload/v1771973120/stockwright/logo-white.svg"
                            alt="Stockwright"
                            className="h-8 lg:h-9 w-auto"
                            style={{
                                filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.25))',
                            }}
                        />
                    </Link>
                    <div className="lp-nav-links">
                        <a href="/#features">What it does</a>
                        <a href="/#workflow">Workflow</a>
                        <a href="/#pricing">Pricing</a>
                        <a href="/#faq">FAQ</a>
                    </div>
                    <Link
                        to="/auth"
                        search={{ mode: 'signup' }}
                        className="lp-nav-cta"
                    >
                        Start free trial →
                    </Link>
                </nav>
            </header>

            {/* Blog intro */}
            <section className="lp-blog-intro">
                <div className="lp-container">
                    <div className="lp-eyebrow">— The Stockwright Journal</div>
                    <h1>
                        The tools and thinking behind a better{' '}
                        <em>resale business</em>.
                    </h1>
                    <p>
                        How software can take the guesswork out of inventory,
                        profit, and tax prep, written by the people who built
                        it.
                    </p>
                </div>
            </section>

            {/* Posts grid */}
            <section className="lp-blog-body">
                <div className="lp-container">
                    <div className="lp-blog-grid">
                        {POSTS.map((post) => (
                            <Link
                                key={post.slug}
                                to="/blog/$slug"
                                params={{ slug: post.slug }}
                                className="lp-post-card"
                            >
                                <div className="lp-post-meta">
                                    <span>{post.category}</span>
                                </div>
                                <h2 className="lp-post-title">{post.title}</h2>
                                <p className="lp-post-excerpt">
                                    {post.excerpt}
                                </p>
                                <div className="lp-post-footer">
                                    <span>{post.date}</span>
                                    <span className="lp-post-arrow">→</span>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="lp-footer pt-16 px-10 pb-24">
                <div className="lp-container">
                    <div className="lp-footer-grid">
                        <div className="lp-footer-brand">
                            <img
                                src="https://res.cloudinary.com/flannery38/image/upload/v1771973120/stockwright/logo.svg"
                                alt="Stockwright"
                                loading="lazy"
                                decoding="async"
                            />
                            <p className="lp-footer-tag">
                                A calm, honest workspace for the resale business
                                you&rsquo;ve quietly been building. Sell more.
                                Stress less.
                            </p>
                        </div>
                        <div className="lp-footer-col">
                            <h5>Product</h5>
                            <a href="/#features">What it does</a>
                            <a href="/#workflow">Workflow</a>
                            <a href="/#integrations">Integrations</a>
                            <a href="/#pricing">Pricing</a>
                        </div>
                        <div className="lp-footer-col">
                            <h5>Company</h5>
                            <Link to="/blog">Journal</Link>
                        </div>
                        <div className="lp-footer-col">
                            <h5>Help</h5>
                            <Link to="/faq">FAQ</Link>
                            <Link to="/terms">Terms</Link>
                            <Link to="/security">Security</Link>
                        </div>
                    </div>
                    <div className="lp-footer-bottom">
                        <span>
                            &copy; {new Date().getFullYear()} Stockwright
                            &middot; Made for resellers
                        </span>
                        <span>Beta &middot; v0.5</span>
                    </div>
                </div>
            </footer>
        </div>
    );
}
